import { ViewEncapsulation } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { OpenLinkById } from '../../common/services/openlinkbyid';
import scrollIntoView from 'scroll-into-view-if-needed';

@Component({
  selector: 'app-superseded-standards',
  templateUrl: './superseded-standards.component.html',
  styleUrls: ['./superseded-standards.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SupersededStandardsComponent implements OnInit {

  header: string;
  subtext: any;
  description: string;
  accordionSubHeading1: string;
  accordionSubHeading2: string;

  topAccordion: { key: string, header: string, content: { dateNumber: number, pageNumber: number, paragraph: any }[], pagination: any[] }[] = [];
  topAccordionMini: { key: string, header: string, content: { dateNumber: number, pageNumber: number, paragraph: any }[] }[] = [];

  bottomAccordion: { key: string, header: string, content: { dateNumber: number, pageNumber: number, paragraph: any }[], pagination: any[] }[] = [];
  bottomAccordionMini: { key: string, header: string, content: { dateNumber: number, pageNumber: number, paragraph: any }[] }[] = [];

  notesHeader: string;
  notesBody: string;
  copyrightNoticeHeader: string;
  copyrightNoticeBody: string;
  archiveLibraryBody: string;
  archiveLibraryLink: string;
  paginationContent = [];
  currentPaginationKey: string;
  selectedIndex: string;
  ascBaseUrl: string;

  constructor(private commonDataServices: CommonDataService, private graphQlServices: GraphqlService, private sanitizer: DomSanitizer, private router: Router, private openlink: OpenLinkById) {
  }

  ngOnInit(): void {
    this.commonDataServices.showLoader.next(true);
   
    this.getSupersededLabel();
  }

  getSupersededLabel() {
    this.graphQlServices.getSupersededStandardsLabels().subscribe(labeldata => {
      if (labeldata != null) {
        this.commonDataServices.showLoader.next(true);
        const labels = labeldata.nodeClass.content.data.labels;
        this.ascBaseUrl = labeldata?.ascLink;
        let accordion1Data = [];
        let accordion2Data = [];
        this.header = this.getLabel("ss_header", labels);
        this.subtext = this.getLabel("ss_subtext", labels);
        this.subtext = this.sanitizer.bypassSecurityTrustHtml(this.subtext);
        this.description = this.getLabel("ss_description", labels);
        this.accordionSubHeading1 = this.getLabel("ss_pronouncementsSubtext", labels);
        this.accordionSubHeading2 = this.getLabel("ss_EITFSubtext", labels);

        this.graphQlServices.getSupersededStandardsAccordionData().subscribe(alldata => {
          if (alldata != null) {
            const accData = alldata.content.data.labels;
            let allAccordionHTML = this.getLabel("ss_all_accordion_content", accData);
            let allAccordionParsedHtml = new DOMParser().parseFromString(allAccordionHTML, 'text/html');
            let allAccordionParaSpan = allAccordionParsedHtml.querySelectorAll('span.para');
            let allAccordionPdfLink = allAccordionParsedHtml.getElementsByClassName('pdf-link');
            let allAccordionSubContentLink = allAccordionParsedHtml.getElementsByClassName('sub-content-link');
            let allAccordionSuperseded = allAccordionParsedHtml.getElementsByClassName('content-superseded');
            for (let i = 0; i < allAccordionPdfLink.length; i++) {//adding pdf image to pdf links
              allAccordionPdfLink[i].classList.add('pdf-link-superseded');
              allAccordionPdfLink[i].innerHTML = '<img src="../../../assets/icons/PDF_icon.svg" alt="PDF" class="pdf-image-superseded">' + allAccordionPdfLink[i].innerHTML + '<img src="../../../assets/icons/new-window-blue.svg" alt="Open PDF Attached" class="pdf-image-superseded">';
            }

            for (let i = 0; i < allAccordionSubContentLink.length; i++) {
              allAccordionSubContentLink[i].classList.add('sub-content-link-superseded');
            }

            for (let i = 0; i < allAccordionSuperseded.length; i++) {
              allAccordionSuperseded[i].classList.add('content-superseded-superseded');
            }

            let accord_stat_fas_content = [];
            let accord_interpretations_fas_content = [];
            let accord_staff_positions_fas_content = [];
            let accord_technical_fas_content = [];
            let accord_abstracts_fas_content = [];
            let accord_abstracts_appendix_fas_content = [];

            allAccordionParaSpan.forEach(span_data => {
              if (span_data.classList.contains('statements')) {
                accord_stat_fas_content.push(span_data);
              }
              else if (span_data.classList.contains('interpretations')) {
                accord_interpretations_fas_content.push(span_data);
              }
              else if (span_data.classList.contains('staff-positions')) {
                accord_staff_positions_fas_content.push(span_data);
              }
              else if (span_data.classList.contains('technical-bulletins')) {
                accord_technical_fas_content.push(span_data);
              }
              else if (span_data.classList.contains('eitf-abstracts')) {
                accord_abstracts_fas_content.push(span_data);
              }
              else if (span_data.classList.contains('eitf-appendix')) {
                accord_abstracts_appendix_fas_content.push(span_data);
              }
            });

            accordion1Data.push({ key: "accord_stat_fas", header: this.getLabel("accord_stat_fas_label", labels), content: accord_stat_fas_content, pagination: this.getLabel("accord_stat_fas_pagination", labels) });
            accordion1Data.push({ key: "accord_interpretations_fas", header: this.getLabel("accord_interpretations_fas_label", labels), content: accord_interpretations_fas_content, pagination: this.getLabel("accord_interpretations_fas_pagination", labels) });
            accordion1Data.push({ key: "accord_staff_positions_fas", header: this.getLabel("accord_staff_positions_fas_label", labels), content: accord_staff_positions_fas_content, pagination: this.getLabel("accord_staff_positions_fas_pagination", labels) });
            accordion1Data.push({ key: "accord_technical_fas", header: this.getLabel("accord_technical_fas_label", labels), content: accord_technical_fas_content, pagination: this.getLabel("accord_technical_fas_pagination", labels) });

            accordion2Data.push({ key: "accord_abstracts_fas", header: this.getLabel("accord_abstracts_fas_label", labels), content: accord_abstracts_fas_content, pagination: this.getLabel("accord_abstracts_fas_pagination", labels) });
            accordion2Data.push({ key: "accord_abstracts_appendix_fas", header: this.getLabel("accord_abstracts_appendix_fas_label", labels), content: accord_abstracts_appendix_fas_content, pagination: this.getLabel("accord_abstracts_appendix_fas_pagination", labels) });

            this.notesHeader = this.getLabel("aicpa_notesHeader", labels);
            this.notesBody = this.getLabel("aicpa_notesBody", labels);
            this.copyrightNoticeHeader = this.getLabel("aicpa_copyrightNoticeHeader", labels);
            this.copyrightNoticeBody = this.getLabel("aicpa_copyrightNoticeBody", labels);
            this.archiveLibraryBody = this.getLabel("aicpa_archiveLibraryBody", labels);
            this.archiveLibraryLink = this.getLabel("aicpa_archiveLibraryLink", labels);


            accordion1Data.forEach(acc_data => {
              var contentacc1 = acc_data.content;
              let spanArray: { dateNumber: number, pageNumber: number, paragraph: any }[] = [];
              contentacc1.forEach(d => {
                let safeHTML = this.sanitizer.bypassSecurityTrustHtml(d.outerHTML);
                let spanId = d.hasAttribute('id') ? d.getAttribute('id') : "";
                let paginationDataString = spanId.split('-').map(a => parseInt(a.trim()));
                let dateNum: number;
                let pageNum: number;
                if (paginationDataString.length == 1) {
                  pageNum = paginationDataString[0];
                }
                else if (paginationDataString.length == 2) {
                  dateNum = paginationDataString[0];
                  pageNum = paginationDataString[1];
                }
                spanArray.push({ dateNumber: dateNum, pageNumber: pageNum, paragraph: safeHTML });
              });
              let pageArray = acc_data.pagination[0].split(',').map(a => a.trim());
              this.topAccordion.push({ key: acc_data.key, header: acc_data.header, content: spanArray, pagination: pageArray });
              this.topAccordionMini.push({ key: acc_data.key, header: acc_data.header, content: [] });
            });

            accordion2Data.forEach(acc_data => {
              let contentacc2 = acc_data.content;
              let spanArray: { dateNumber: number, pageNumber: number, paragraph: any }[] = [];
              contentacc2.forEach(d => {
                let safeHTML = this.sanitizer.bypassSecurityTrustHtml(d.outerHTML);
                let paginationDataString = d.getAttribute('id').split('-').map(a => parseInt(a.trim()));
                let dateNum: number;
                let pageNum: number;
                if (paginationDataString.length == 1) {
                  pageNum = paginationDataString[0];
                }
                else if (paginationDataString.length == 2) {
                  dateNum = paginationDataString[0];
                  pageNum = paginationDataString[1];
                }
                spanArray.push({ dateNumber: dateNum, pageNumber: pageNum, paragraph: safeHTML });
              });
              let pageArray = acc_data.pagination[0].split(',').map(a => a.trim());
              this.bottomAccordion.push({ key: acc_data.key, header: acc_data.header, content: spanArray, pagination: pageArray });
              this.bottomAccordionMini.push({ key: acc_data.key, header: acc_data.header, content: [] });
            });

            this.commonDataServices.showLoader.next(false);
          }
        }, err => {
          console.log(err);
          this.commonDataServices.showLoader.next(false);
        });
      }
    }, err => {
      console.log(err);
      this.commonDataServices.showLoader.next(false);
    });
  }

  getLabel(_key: string, _labels: any): any {
    return _labels.filter(x => x.key == _key).map(y => y.value);
  }

  openLinkById(event) {
    if (event.target.classList.contains('sub-content-link')) {
      event.target.id = this.ascBaseUrl + event.target.id;
      this.openlink.openLinkById(event, true);
      event.target.id = event.target.id.replace(this.ascBaseUrl, '');
    }
    else {
      this.openlink.openLinkById(event, true);
    }
  }

  openRouterLink(event) {
    this.openlink.openLinkById(event);
  }

  accordionOpenEvent(accordionKey) {
    let allAccordionData = this.topAccordion.concat(this.bottomAccordion);
    allAccordionData.forEach(currentAccordion => {
      if (currentAccordion.key === accordionKey) {
        let startRange = this.stringRangeToNumber(currentAccordion.pagination[0]);
        this.SetMiniArrayContentFromRange(startRange, currentAccordion);
        //pagination view set and current page set
        this.paginationContent = currentAccordion.pagination;
        this.currentPaginationKey = accordionKey;//need this for whenever another accordion is opened and old one is closed
        this.selectedIndex = currentAccordion.pagination[0];
      }
    });
  }

  accordionCloseEvent(accordionKey) {
    let allAccordionData = this.topAccordion.concat(this.bottomAccordion);
    allAccordionData.forEach(d => {
      if (d.key === accordionKey) {
        if (this.currentPaginationKey === accordionKey) {
          this.paginationContent = [];
        }
      }
    });
  }

  paginationClick(event) {
    this.selectedIndex = event.currentTarget.innerText;
    let numberRange = this.stringRangeToNumber(this.selectedIndex);
    let key = this.currentPaginationKey;
    let allAccordionData = this.topAccordion.concat(this.bottomAccordion);
    allAccordionData.forEach(currentAccordion => {
      if (currentAccordion.key == key) {
        this.SetMiniArrayContentFromRange(numberRange, currentAccordion);
        //scroll to top
        let openedAccordionDiv = document.getElementById(currentAccordion.header);
        // openedAccordionDiv.scrollIntoView({ behavior: 'smooth' });
        scrollIntoView(openedAccordionDiv, {
          scrollMode: 'always',
          block: 'start',
          inline: 'start',
          behavior: 'smooth',
          boundary: document.getElementsByTagName('app-main-content')[0]
        })
      }
    });
  }

  stringRangeToNumber(stringRange: string): number[] {
    let numberList = [];
    let textSplit = stringRange.split('-').map(d => d.trim());
    textSplit.forEach(s => {
      let item = s.split('').map(a => a.trim());
      let eachNumber = '';
      item.forEach(i => {
        eachNumber += parseInt(i).toString().replace('NaN', '');
      });
      numberList.push(parseInt(eachNumber));
    });
    let filteredNumberList = numberList.filter(a => !Number.isNaN(a));
    return filteredNumberList;
  }

  SetMiniArrayContentFromRange(range: number[], accordion: any) {
    let start: number;
    let end: number;
    let dateStart: number;
    let dateEnd: number;
    let accordionContentLength: number = accordion.content.length;
    let allContent: { dateNumber: number, pageNumber: number, paragraph: any }[] = [];

    if (range.length === 4) {
      //convert number to date
      //convert two digit date to 4 digit
      let year1 = range[0] > 50 ? (1900 + range[0]) : (2000 + range[0]);
      let year2 = range[2] > 50 ? (1900 + range[2]) : (2000 + range[2]);

      if (year1 < year2) {
        dateStart = year1;
        dateEnd = year2;
      }
      else {
        dateStart = year2;
        dateEnd = year1;
      }

      start = range[1];
      end = range[3];

      dateloop:
      while (dateStart <= dateEnd) {
        while (start <= accordionContentLength) {
          accordion.content.forEach(a => {
            if (a.pageNumber === start && a.dateNumber === (dateStart % 100)) {
              allContent.push(a);
            }
          });
          if (dateStart === dateEnd && start === end) {
            break dateloop;
          }
          start++;
        }
        dateStart++;
        start = 1;
      }

    }
    else if (range.length === 2) {

      if (range[0] < range[1]) {
        start = range[0];
        end = range[1];
      }
      else {
        start = range[1];
        end = range[0];
      }

      for (let page = start; page <= end; page++) {
        accordion.content.forEach(a => {
          if (a.pageNumber === page) {
            allContent.push(a);
          }
        });
      }
    }
    else if (range.length === 0) {

      allContent = accordion.content;
    }

    this.topAccordionMini.forEach(a => {
      if (a.key === accordion.key) {
        a.content = allContent;
      }
    });

    this.bottomAccordionMini.forEach(a => {
      if (a.key === accordion.key) {
        a.content = allContent;
      }
    });
  }
}
